import axios from "axios";
import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();
// Gets the logged in user data from local session

// Gets the logged in user data from local session
export const getLoggedUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedUser() !== null;
};

// Register Method
export const postRegister = (data: any) => api.create(url.POST_REGISTER, data);

// Login Method
export const postLogin = async (data: any) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/connect/token`,
    new URLSearchParams({
      grant_type: 'password',
      client_id: 'Platform_App',
      username: data.userNameOrEmailAddress,
      password: data.password,
      scope: 'Platform  offline_access',
    }),
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );

  return response;
}

// Logout Method
export const getLogout = (data: any) => api.get(url.GET_LOGOUT, data);

// postForgetPwd
export const postForgetPwd = (data: any) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);
